// extracted by mini-css-extract-plugin
export default {"FeelsLikeWrapper":"FeelsLike_FeelsLikeWrapper__Fk3dG","FeelsLikeText":"FeelsLike_FeelsLikeText__4ZcMI","UnitsText":"FeelsLike_UnitsText__zO1vY"};